/**
 * @prettier
 * @flow
 */
import TextField from '@material-ui/core/TextField';
import * as React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { translate } from 'src/utils/translate/translate';

export function FormTextField({ name, label, placeholder, helperText, value, onChange, variant = 'outlined', required, disabled, InputProps, rules, defaultValue = '' }: Props) {
    const {
        errors,
        control,
        formState: { isSubmitting },
    } = useFormContext();

    return (
        <Controller
            as={TextField}
            name={name}
            label={label}
            placeholder={placeholder}
            helperText={errors[name]?.message ?? helperText}
            rules={{
                required: rules?.required && {
                    value: rules?.required ?? (rules?.required: any)?.value,
                    message: (rules?.required: any)?.message ?? translate('This field is required'),
                },
                pattern: rules?.email && {
                    value: /.*@.*\..*/,
                    message: (rules?.email: any)?.message ?? translate('Must be an email'),
                },
                min: rules?.min && {
                    value: rules?.min ?? (rules?.min: any)?.value,
                    message: (rules?.min: any)?.message ?? translate('Must be number less than @number', { number: (rules?.min: any) }),
                },
                max: rules?.max && {
                    value: rules?.max ?? (rules?.max: any)?.value,
                    message: (rules?.max: any)?.message ?? translate('Must be number larger than @number', { number: (rules?.max: any) }),
                },
                minLength: rules?.minLength && {
                    value: rules?.minLength ?? (rules?.minLength: any)?.value,
                    message: (rules?.minLength: any)?.message ?? translate('Must be at least @number characters', { number: (rules?.minLength: any) }),
                },
                maxLength: rules?.maxLength && {
                    value: rules?.maxLength ?? (rules?.maxLength: any)?.value,
                    message: (rules?.maxLength: any)?.message ?? translate('Must be at most @number characters', { number: (rules?.maxLength: any) }),
                },
            }}
            error={errors[name]}
            InputProps={InputProps}
            InputLabelProps={{ shrink: placeholder ? true : undefined }}
            value={value}
            onChange={onChange}
            variant={variant}
            required={required}
            disabled={isSubmitting || disabled}
            fullWidth
            control={control}
            defaultValue={defaultValue}
        />
    );
}

export type Props = {|
    name: string,
    label?: string,
    placeholder?: string,
    helperText?: string,
    value?: string,
    onChange?: string,
    variant?: 'filled' | 'outlined' | 'standard',
    required?: boolean,
    disabled?: boolean,
    rules?: {|
        required?: boolean,
        email?: boolean,
        min?: number | { message: string, value: number },
        max?: number | { message: string, value: number },
        minLength?: number | { message: string, value: number },
        maxLength?: number | { message: string, value: number },
    |},
    InputProps?: any,
    defaultValue?: string,
|};
